// 引入数据配置文件
import FormConfig from "../formConfig.js";
import { fun_PostAction, fun_GetAction, fun_Download } from "@/api/index";
// 引入转译方法
import { fun_DownloadFile } from "@/utils/validate";
import CaLock from "@/components/common/calock";
import ConstructionChoose from "../../components/constructionChooseDialog/index.vue";
import AuditHistoryRecord from "../../../components/auditHistoryRecord/index.vue";
import ProjectApplicationDetail from "../projectApplicationDetail/index.vue";
import { Loading } from "element-ui";
// 引入附件上传页面
import TenderPictureinfor from "../../../components/tenderPictureinfor/index.vue";

export default {
  data() {
    return {
      // 判断是否从工作台进入
      workbenchMenu: null,
      // 工作台状态
      workbenchState: false,
      // 流程状态
      stepsActive: 0,
      // 流程数据
      stepsList: [
        {
          name: "项目信息导入",
          isSave: false, // 是否保存
          isActive: true, // 是否可点击
          formList: FormConfig.projectInformation()
        },
        {
          name: "建设信息",
          isSave: false,
          isActive: true,
          formList: FormConfig.biddingInformation()
        },
        {
          name: "项目基本信息",
          isSave: false,
          isActive: true,
          formList: FormConfig.basicProjectInformation()
        },
        // {
        //   name: "工程概况",
        //   isSave: false,
        //   isActive: false,
        //   formList: FormConfig.projectOverview(),
        // },
        {
          name: "其他信息",
          isSave: false,
          isActive: true,
          formList: FormConfig.noOtherInformation()
        }
      ],
      // 表单配置
      formConfigList: FormConfig.projectInformation(),
      // 表单绑定值
      form: {
        id: null, // 主键
        state: null, // 状态
        applicationId: null,
        dataType: null,
        constructionFlagProject: null,
        loginNo: null, // 登录号
        loginPwd: null, // 密码
        relateCode: null, // 项目类别关联代码
        investProjectCode: null, // 投资项目统一代码
        tenderCorpChangeType: null, // 招标人变更类型
        buildCorpName: null, // 现建设单位名称
        buildCorpCode: null, // 现建设单位组织机构代码
        buildCorpAddress: null, // 现建设单位地址
        buildCorpLegal: null, // 现建设单位法定代表人
        buildCorpProperty: null, // 现建设单位单位性质
        buildCorpLinkMan: null, // 现建设单位联系人
        buildCorpLinkTel: null, // 现建设单位联系人电话
        buildCorpLinkMobile: null, // 现建设单位联系人手机
        buildCorpPostalCode: null, // 现建设单位邮编
        buildCorpFax: null, // 现建设单位传真
        buildCorpEMail: null, // 现建设单位电子邮件
        constructionNo: null, // 报建编号
        prjName: null, // 工程名称
        prjAddress: null, // 工程地点
        prjLargeClass: null, // 工程类别
        prjCategory: null, // 工程小类
        noteNumber: null, // 立项文号
        approveLevel: null, // 立项级别
        approveType: null, // 立项形式
        approveUnit: null, // 批准单位
        totalInvestment: null, // 批准投资总额
        investmentPlanThisYear: null, // 本年度投资计划
        stateProfitInvestment: null, // 国有盈利性投资
        stateNonprofitInvestment: null, // 国有非盈利性投资
        nonstateInvestment: null, // 非国有投资
        foreignInvestment: null, // 外资
        industryClass: null, // 项目行业门类
        industryCode: null, // 项目行业分类
        industryClassProvince: null, // 项目行业分类（湖北省）
        regulators: null, // 行政监督部门
        projectScale: null, // 工程规模
        constructionType: null, // 报建性质
        constructionGrade: null, // 报建等级
        isKeyProject: null, // 重点工程
        layersFollowingThirtyTwo: null, // 规划建筑层数32层以下
        layersAboveThirtyTwo: null, // 规划建筑层数32层（含）以上
        depthFollowingNine: null, // 深基坑深度9米以下
        depthAboveNine: null, // 深基坑深度9米（含）以上
        heightFollowingOneHundred: null, // 建筑高度100米以下
        heightAboveOneHundred: null, // 建筑高度100米（含）以上
        spanFollowingThirtyTwo: null, // 公共建筑跨度30米以下
        spanAboveThirtyTwo: null, // 公共建筑跨度30米（含）以上
        isRealEstateProject: null, // 是否房地产开发
        isIndustryProject: null, // 是否工业项目
        description: null, // 备注
        opinion: null, // 报建单位意见
        handleOpinion: null, // 办理意见
        constructionFlag: null,
        inputPerson: null,
        inputMode: null,
        insertDate: null,
        updateDate: null,
        firstConstructionId: null, // 原建设方（甲方）报建主键
        firstConstructionNo: null, // 原建设方（甲方）报建编号
        firstConstructionPrjName: null, // 工程名称
        isAudit: null, // 是否需要核验
        digitalSignature: null, // 数字签名
        lockNo: null, // 锁编号
        projectType: null, // 项目类型
        transactionId: null, // 交易目录名称
        isConstructionProject: null, // 是否工程建设项目
        tenderMethod: null, // 招标组织形式
        regionCode: null, // 项目所在行政区域
        agencyCorpName: null, // 招标代理机构名称
        agenctCorpAddress: null, // 招标代理机构地址
        agencyLinkMan: null, // 招标代理机构联系人
        agencyLinkPhone: null // 招标代理机构联系人电话
      },
      // 表单错误提示
      errRules: {
        id: null, // 主键
        state: null, // 状态
        applicationId: null,
        dataType: null,
        constructionFlagProject: null,
        loginNo: null, // 登录号
        loginPwd: null, // 密码
        relateCode: null, // 项目类别关联代码
        investProjectCode: null, // 投资项目统一代码
        tenderCorpChangeType: null, // 招标人变更类型
        buildCorpName: null, // 现建设单位名称
        buildCorpCode: null, // 现建设单位组织机构代码
        buildCorpAddress: null, // 现建设单位地址
        buildCorpLegal: null, // 现建设单位法定代表人
        buildCorpProperty: null, // 现建设单位单位性质
        buildCorpLinkMan: null, // 现建设单位联系人
        buildCorpLinkTel: null, // 现建设单位联系人电话
        buildCorpLinkMobile: null, // 现建设单位联系人手机
        buildCorpPostalCode: null, // 现建设单位邮编
        buildCorpFax: null, // 现建设单位传真
        buildCorpEMail: null, // 现建设单位电子邮件
        constructionNo: null, // 报建编号
        prjName: null, // 工程名称
        prjAddress: null, // 工程地点
        prjLargeClass: null, // 工程类别
        prjCategory: null, // 工程小类
        noteNumber: null, // 立项文号
        approveLevel: null, // 立项级别
        approveType: null, // 立项形式
        approveUnit: null, // 批准单位
        totalInvestment: null, // 批准投资总额
        investmentPlanThisYear: null, // 本年度投资计划
        stateProfitInvestment: null, // 国有盈利性投资
        stateNonprofitInvestment: null, // 国有非盈利性投资
        nonstateInvestment: null, // 非国有投资
        foreignInvestment: null, // 外资
        industryClass: null, // 项目行业门类
        industryCode: null, // 项目行业分类
        industryClassProvince: null, // 项目行业分类（湖北省）
        regulators: null, // 行政监督部门
        projectScale: null, // 工程规模
        constructionType: null, // 报建性质
        constructionGrade: null, // 报建等级
        isKeyProject: null, // 重点工程
        layersFollowingThirtyTwo: null, // 规划建筑层数32层以下
        layersAboveThirtyTwo: null, // 规划建筑层数32层（含）以上
        depthFollowingNine: null, // 深基坑深度9米以下
        depthAboveNine: null, // 深基坑深度9米（含）以上
        heightFollowingOneHundred: null, // 建筑高度100米以下
        heightAboveOneHundred: null, // 建筑高度100米（含）以上
        spanFollowingThirtyTwo: null, // 公共建筑跨度30米以下
        spanAboveThirtyTwo: null, // 公共建筑跨度30米（含）以上
        isRealEstateProject: null, // 是否房地产开发
        isIndustryProject: null, // 是否工业项目
        description: null, // 备注
        opinion: null, // 报建单位意见
        handleOpinion: null, // 办理意见
        constructionFlag: null,
        inputPerson: null,
        inputMode: null,
        insertDate: null,
        updateDate: null,
        firstConstructionId: null, // 原建设方（甲方）报建主键
        firstConstructionNo: null, // 原建设方（甲方）报建编号
        firstConstructionPrjName: null, // 工程名称
        isAudit: null, // 是否需要核验
        digitalSignature: null, // 数字签名
        lockNo: null, // 锁编号
        projectType: null, // 项目类型
        transactionId: null, // 交易目录名称
        isConstructionProject: null, // 是否工程建设项目
        tenderMethod: null, // 招标组织形式
        regionCode: null, // 项目所在行政区域
        transactionFlag: null, // 交易目录标志
        agencyCorpName: null, // 招标代理机构名称
        agenctCorpAddress: null, // 招标代理机构地址
        agencyLinkMan: null, // 招标代理机构联系人
        agencyLinkPhone: null // 招标代理机构联系人电话
      },
      // 全局加载
      fullLoading: null,
      // 文件下载路径
      url: null,
      // 主键
      id: this.$route.query.id,
      // 操作类型
      controllerFlg: this.$route.query.controllerFlg, // 操作标志
      options: [], // 交易目录名称下拉框内容
      // 用于判断状态图片
      flagState: null
    };
  },

  // 注册组件
  components: {
    CaLock, // CA锁
    ConstructionChoose,
    AuditHistoryRecord, // 历史核验记录
    ProjectApplicationDetail,
    TenderPictureinfor // 附件页面
  },
  // 模板编译前
  created() {
    // 获取数据
    this.workbenchMenu = sessionStorage.getItem("workbenchMenu")
      ? sessionStorage.getItem("workbenchMenu")
      : null;
  },
  // 模板编译完成
  mounted() {
    // 默认获取第一个流程表单
    this.formConfigList = this.stepsList[this.stepsActive].formList;
    // 获取下载路径
    this.fun_GetFilePath();
    // 获取下拉框数据
    this.fun_TransactionDirectoryComboTree();
    // 不为新增的时候
    if (this.controllerFlg != "insert") {
      // 获取详情
      this.fun_GetDetail();
      // 是否报建项目
      this.form.transactionFlag = this.$route.query.transactionFlag;
      // 重新加载节点
      this.fun_ReloadStepList();
      // 如果是详情
      if (this.controllerFlg === "detail") {
        // 遍历流程
        this.stepsList.map(e => {
          (e.isSave = true), // 默认保存
            (e.isActive = true); // 默认可点击
          // 遍历标签页
          e.formList.map(formList => {
            // 遍历标签页内表单
            formList.formConfigList.map(form => {
              // 置灰
              form.disabled = true;
            });
          });
        });
        this.formConfigList.map(form => {
          // 遍历标签页内表单
          form.formConfigList.map(e => {
            // 置灰
            e.disabled = true;
          });
        });
      }
    } else {
      // 初始化
      this.fun_InsertInit();
    }
    // 报建项目 不为详情时
    if (this.form.transactionFlag != "0" && this.controllerFlg !== "detail") {
      // 声明需要过滤掉的数据
      var arr = ["项目登记单位意见", "办理意见"];
      // 遍历流程
      this.stepsList.map(e => {
        // 判断是其他信息
        if (e.name === "其他信息") {
          // 删除
          e.formList = e.formList.filter(item => !arr.includes(item.title));
        }
      });
    }
  },
  // 自定义方法
  methods: {
    /**
     * 添加初始化
     */
    fun_InsertInit() {
      // 非报建项目
      if (this.form.constructionFlag != "1") {
        // 发起请求
        fun_PostAction("/nonConstruction/insertInit", {id: this.form.id}).then(res => {
          // 结构res.data
          const { result, data, msg } = res.data;
          // 请求成功
          if (result) {
            // 主键
            this.form.id = data.data.id;
            // 建设单位名称
            this.form.buildCorpName = data.data.buildCorpName;
            // 组织机构代码
            this.form.buildCorpCode = data.data.buildCorpCode;
            // 地址
            this.form.buildCorpAddress = data.data.buildCorpAddress;
            // 法人
            this.form.buildCorpLegal = data.data.buildCorpLegal;
            // 联系人
            this.form.buildCorpLinkMan = data.data.buildCorpLinkMan;
            // 联系电话
            this.form.buildCorpLinkTel = data.data.buildCorpLinkTel;
            // 联系手机
            this.form.buildCorpLinkMobile = data.data.buildCorpLinkMobile;
            // 邮政编码
            this.form.buildCorpPostalCode = data.data.buildCorpPostalCode;
            // 传真
            this.form.buildCorpFax = data.data.buildCorpFax;
            // 电子邮箱
            this.form.buildCorpEMail = data.data.buildCorpEMail;
            // 建设单位单位性质
            this.form.buildCorpProperty = data.data.buildCorpProperty;
          } else {
            // 提示请求失败的信息
            this.$message.error(msg);
          }
        });
        // 报建项目
      } else {
        // 发起请求
        fun_PostAction("/construction/insertInit", {id: this.form.id}).then(res => {
          // 结构res.data
          const { result, data, msg } = res.data;
          // 请求成功
          if (result) {
            // 主键
            this.form.id = data.data.id;
            // 建设单位名称
            this.form.buildCorpName = data.data.buildCorpName;
            // 组织机构代码
            this.form.buildCorpCode = data.data.buildCorpCode;
            // 地址
            this.form.buildCorpAddress = data.data.buildCorpAddress;
            // 法人
            this.form.buildCorpLegal = data.data.buildCorpLegal;
            // 联系人
            this.form.buildCorpLinkMan = data.data.buildCorpLinkMan;
            // 联系电话
            this.form.buildCorpLinkTel = data.data.buildCorpLinkTel;
            // 联系手机
            this.form.buildCorpLinkMobile = data.data.buildCorpLinkMobile;
            // 邮政编码
            this.form.buildCorpPostalCode = data.data.buildCorpPostalCode;
            // 传真
            this.form.buildCorpFax = data.data.buildCorpFax;
            // 电子邮箱
            this.form.buildCorpEMail = data.data.buildCorpEMail;
            // 建设单位单位性质
            this.form.buildCorpProperty = data.data.buildCorpProperty;
            // 设置类型--默认为0--报建旧数据
            this.form.dataType = "0";
          } else {
            // 提示请求失败的信息
            this.$message.error(msg);
          }
        });
      }
    },
    /**
     * 需要处理页面显示逻辑代码
     */
    fun_GetHandle() {
      // 如果是委托招标
      if (this.form.tenderMethod == "2") {
        // 遍历表单
        this.stepsList[1].formList[1].formConfigList.map(f => {
          // 如果是招标代理数据
          if (
            f.value === "agencyCorpName" ||
            f.value === "agenctCorpAddress" ||
            f.value === "agencyLinkMan" ||
              f.value === "agencyLinkPhone"
          ) {
            f.disabled = false; // 取消置灰
            f.rule.required = true; // 设置成必填
          }
        });
      } else {
        // 遍历表单
        this.stepsList[1].formList[1].formConfigList.map(f => {
          // 如果是招标代理数据
          if (
            f.value === "agencyCorpName" ||
            f.value === "agenctCorpAddress" ||
            f.value === "agencyLinkMan" ||
            f.value === "agencyLinkPhone"
          ) {
            f.disabled = true; // 置灰
            f.rule.required = false; // 设置成非必填
          }
        });
      }
      // 如果项目关联代码为无
      if (this.form.relateCode == "0") {
        // 遍历查询表单
        this.formConfigList[0].formConfigList.map(e => {
          // 如果是投资项目统一代码
          if (e.value === "investProjectCode") {
            e.disabled = true; // 置灰
            e.rule.required = false; // 设置成非必填
          }
        });
      }
      // 工程类别不为空
      if(this.form.prjLargeClass){
        // 遍历查询表单
        this.stepsList[2].formList[0].formConfigList.map(e => {
          // 如果是工程小类
          if (e.value === "prjCategory") {
            // 修改下拉框请求参数，重新赋值
            e.queryParams = {
              url: "/dataDictionaryEntries/engineeringCombobox",
              parentId: this.form.prjLargeClass
            };
          }
        });
      }
      // 项目行业门类不为空
      if(this.form.industryClass){
        // 遍历查询表单
        this.stepsList[0].formList[2].formConfigList.map(e => {
          // 如果是项目行业分类
          if (e.value === "industryCode") {
            // 修改下拉框请求参数，重新赋值
            e.queryParams = {
              url: "/industryCode/IndustryCodeCombobox",
              industryId: this.form.industryClass,
              flag: 0
            };
          }
        });
      }
      // 如果是目录类
      if(this.form.transactionId && this.form.transactionId != "0"){
        // 遍历查询表单
        this.stepsList[0].formList[3].formConfigList.map(f => {
          // 如果是行政监督部门
          if (f.value === "regulators") {
            // 修改下拉框请求参数，重新赋值
            f.queryParams = {
              url: "/departmentByTransCodeCombobox",
              purchaserId: this.form.transactionId
            };
          }
        });
      }
      // 非报建项目
      if (this.form.transactionFlag != "1") {
        // 招标人甲方变更为空
        if (
          this.form.tenderCorpChangeType == "" ||
          this.form.tenderCorpChangeType == null
        ) {
          // 是否存在
          let rtn = false;
          // 表单下标
          let configNum = 0;
          // 遍历查询表单
          this.stepsList[3].formList.map((item, num) => {
            // 如果是监管部门意见
            if (item.title === "监管部门意见") {
              // 设置为存在
              rtn = true;
              // 设置表单下标
              configNum = num;
            }
          });
          // 如果存在
          if (rtn) {
            // 删除
            this.stepsList[3].formList.splice(configNum, 1);
          }
        }
      }
      // 如果是报建类项目
      else {
        // 是否存在
        let rtn = false;
        // 表单下标
        let configNum = 0;
        // 遍历查询表单
        this.stepsList[3].formList.map((item, num) => {
          // 如果是监管部门意见
          if (item.title === "监管部门意见") {
            // 设置为存在
            rtn = true;
            // 设置表单下标
            configNum = num;
          }
        });
        // 如果存在
        if (rtn) {
          // 删除
          this.stepsList[3].formList.splice(configNum, 1);
        }
        // 如果数据类型不为0或者空
        if (this.form.dataType != "0" && this.form.dataType != "") {
          // 遍历查询表单
          this.stepsList[3].formList[0].formConfigList.map(e => {
            // 如果是规划建筑层数32层以下
            if (e.value === "layersFollowingThirtyTwo") {
              e.label = "规划建筑层数50层以下："; //
            }
            // 如果是规划建筑层数32层（含）以上
            else if (e.value === "layersAboveThirtyTwo") {
              e.label = "规划建筑层数50层（含）以上："; //
            }
            // 如果是深基坑深度9米以下
            else if (e.value === "depthFollowingNine") {
              e.label = "深基坑深度12米以下："; //
            }
            // 如果是深基坑深度9米（含）以上
            else if (e.value === "depthAboveNine") {
              e.label = "深基坑深度12米（含）以上："; //
            }
            // 如果是建筑高度50米以下
            else if (e.value === "heightFollowingOneHundred") {
              e.label = "建筑高度50米以下："; //
            }
            // 如果是建筑高度50米（含）以上
            else if (e.value === "heightAboveOneHundred") {
              e.label = "建筑高度50米（含）以上："; //
            }
          });
        }
      }
    },
    /**
     * 获取详情
     */
    fun_GetDetail() {
      // 发起请求
      fun_GetAction("/construction/getDetail", {
        id: this.id
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 请求成功
        if (result) {
          // 表格数据
          this.form = data.tbConstruction;
          // 获取状态用于判断显示图片
          this.flagState = data.tbConstruction.state;
          // 工作台状态
          this.workbenchState = data.workbenchState;
          // 执行处理页面显示方法
          this.fun_GetHandle();
        } else {
          // 提示请求失败的信息
          this.$message.error(msg);
        }
      });
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i, arr) {
      // 赋值
      this.form[i] = e;
      // 项目类别关联代码
      if (i === "relateCode") {
        // 如果选的是无
        if (e == "0") {
          // 清空
          this.form.investProjectCode = null;
          // 遍历查询表单
          this.stepsList[0].formList[1].formConfigList.map(f => {
            // 如果是投资项目统一代码
            if (f.value === "investProjectCode") {
              f.disabled = true; // 置灰
              f.rule.required = false; // 设置成非必填
            }
          });
        } else {
          // 遍历查询表单
          this.stepsList[0].formList[1].formConfigList.map(f => {
            // 如果是投资项目统一代码
            if (f.value === "investProjectCode") {
              f.disabled = false; // 取消置灰
              f.rule.required = true; // 设置成必填
            }
          });
        }
      }
      // 工程类别
      else if (i === "prjLargeClass") {
        // 遍历查询表单
        this.stepsList[2].formList[0].formConfigList.map(f => {
          // 如果是工程小类
          if (f.value === "prjCategory") {
            // 修改下拉框请求参数，重新赋值
            f.queryParams = {
              url: "/dataDictionaryEntries/engineeringCombobox",
              parentId: this.form.prjLargeClass
            };
          }
        });
      }
      // 项目行业门类
      else if (i === "industryClass") {
        // 清空项目行业分类值
        this.form.industryCode = null;
        // 遍历表单
        this.stepsList[0].formList[2].formConfigList.map(f => {
          // 如果是项目行业分类
          if (f.value === "industryCode") {
            // 修改下拉框请求参数，重新赋值
            f.queryParams = {
              url: "/industryCode/IndustryCodeCombobox",
              industryId: this.form.industryClass,
              flag: 0
            };
          }
        });
      }
      // 招标组织形式
      else if (i === "tenderMethod") {
        // 如果是自行招标
        if (e == "1") {
          // 清空招标代理机构名称
          this.form.agencyCorpName = "";
          // 清空招标代理机构地址
          this.form.agenctCorpAddress = "";
          // 清空招标代理机构联系人
          this.form.agencyLinkMan = "";
          // 清空招标代理机构联系人电话
          this.form.agencyLinkPhone = "";
          // 遍历表单
          this.stepsList[1].formList[1].formConfigList.map(f => {
            // 如果是招标代理数据
            if (
              f.value === "agencyCorpName" ||
              f.value === "agenctCorpAddress" ||
              f.value === "agencyLinkMan" ||
              f.value === "agencyLinkPhone"
            ) {
              f.disabled = true; // 置灰
              f.rule.required = false; // 设置成非必填
            }
          });
        }
        // 如果是委托招标
        else {
          // 遍历表单
          this.stepsList[1].formList[1].formConfigList.map(f => {
            // 如果是招标代理数据
            if (
              f.value === "agencyCorpName" ||
              f.value === "agenctCorpAddress" ||
              f.value === "agencyLinkMan" ||
              f.value === "agencyLinkPhone"
            ) {
              f.disabled = false; // 取消置灰
              f.rule.required = true; // 设置成必填
            }
          });
        }
      }
      // 项目类型
      else if (i === "projectType") {
        // 清空行政监督部门
        this.form.regulators = "";
        // 如果是目录类
        if (e === "0") {
          // 遍历查询表单
          this.stepsList[0].formList[3].formConfigList.map(f => {
            // 如果是交易目录名称
            if (f.value === "transactionId") {
              f.disabled = false; // 取消置灰
              f.rule.required = true; // 设置成必填
            }
            // 如果是行政监督部门
            if (f.value === "regulators") {
              // 修改下拉框请求参数，重新赋值
              f.queryParams = {
                url: "/regulatorsCombobox",
                processType: "202303021543330348"
              };
            }
          });
          // 遍历表单
          this.stepsList[1].formList[1].formConfigList.map(f => {
            // 如果是招标组织形式数据
            if (f.value === "tenderMethod") {
              f.disabled = true; // 置灰
              f.rule.required = false; // 设置成非必填
            }
          });
        }
        // 如果是非目录类
        else {
          // 清空交易目录名称
          this.form.transactionId = "";
          // 清空交易记录标志
          this.form.transactionFlag = "0";
          // 清空建设工程标识
          this.form.constructionFlag = "0";
          // 遍历查询表单
          this.stepsList[0].formList[3].formConfigList.map(f => {
            // 如果是交易目录名称
            if (f.value === "transactionId") {
              f.disabled = true; // 置灰
              f.rule.required = false; // 设置成非必填
            }
            // 如果是行政监督部门
            if (f.value === "regulators") {
              // 修改下拉框请求参数，重新赋值
              f.queryParams = {
                url: "/regulatorsCombobox",
                processType: "201512011001350003"
              };
            }
          });
          // 遍历表单
          this.stepsList[1].formList[1].formConfigList.map(f => {
            // 如果是招标组织形式数据
            if (f.value === "tenderMethod") {
              f.disabled = false; // 取消置灰
              f.rule.required = true; // 设置成必填
            }
          });
        }
      }
      // 如果是交易目录名称
      else if (i === "transactionId") {
        // 清空行政监督部门
        this.form.regulators = "";
        // 如果长度大于0
        if (e.length > 0) {
          // 赋值
          this.form.transactionId = e[e.length - 1];
        } else {
          // 赋值
          this.form.transactionId = e;
        }
        // 遍历查询表单
        this.stepsList[0].formList[3].formConfigList.map(f => {
          // 如果是行政监督部门
          if (f.value === "regulators") {
            // 修改下拉框请求参数，重新赋值
            f.queryParams = {
              url: "/departmentByTransCodeCombobox",
              purchaserId: this.form.transactionId
            };
          }
        });
      }
    },
    /**
     * 点击流程
     */
    fun_GetClickSteps(val, index) {
      // 判断是否可点击
      if (val.isActive) {
        // 是否填写当前表单
        if (this.fun_GetStepsIsData()) {
          // 设置当前流程已保存
          this.stepsList[this.stepsActive].isSave = true;
        }
        // 如果不是详情
        if (this.controllerFlg !== "detail") {
          // 判断是否填写项目名称
          if (!this.form.prjName) {
            // 提示
            this.$alert("请填写项目名称！", "warning");
            this.errRules.prjName = "请填写项目名称！";
            return false;
          }
          // 保存当前表单
          this.fun_NextSaveOrUpdate("bc");
        }
        // 赋值下标
        this.stepsActive = index;
        // 获取表单数据
        this.formConfigList = val.formList;
        // 判断项目行业分类是否有值
        if (this.form.industryCode) {
          // 遍历表单
          this.stepsList[0].formList[2].formConfigList.map(f => {
            // 如果是项目行业分类
            if (f.value === "industryCode") {
              // 修改下拉框请求参数，重新赋值
              f.queryParams = {
                url: "/industryCode/IndustryCodeCombobox",
                industryId: this.form.industryClass,
                flag: 0
              };
            }
          });
        } else {
          // 清空项目行业分类值
          this.form.industryCode = null;
        }
      }
    },
    /**
     * 上一步
     */
    fun_GetLastStep() {
      // 如果不是详情
      if (this.controllerFlg !== "detail") {
        // 判断是否填写项目名称
        if (!this.form.prjName) {
          // 提示
          this.$alert("请填写项目名称！", "warning");
          this.errRules.prjName = "请填写项目名称！";
          return false;
        }
        // 保存当前表单
        this.fun_NextSaveOrUpdate("bc");
      }
      // 是否填写当前表单
      if (this.fun_GetStepsIsData()) {
        // 设置当前流程已保存
        this.stepsList[this.stepsActive].isSave = true;
      }
      // 减1
      this.stepsActive--;
      // 获取表单数据
      this.formConfigList = this.stepsList[this.stepsActive].formList;
    },
    /**
     * 下一步
     */
    fun_GetNextStep() {
      // 如果不是详情
      if (this.controllerFlg !== "detail") {
        // 判断是否填写项目名称
        if (!this.form.prjName) {
          // 提示
          this.$alert("请填写项目名称！", "warning");
          this.errRules.prjName = "请填写项目名称！";
          return false;
        }
        // 保存当前表单
        this.fun_NextSaveOrUpdate("bc");
      }
      // 是否填写当前表单
      if (this.fun_GetStepsIsData()) {
        // 设置当前流程已保存
        this.stepsList[this.stepsActive].isSave = true;
      }
      // 加1
      this.stepsActive++;
      // 设置下一个流程可点击
      this.stepsList[this.stepsActive].isActive = true;
      // 获取表单数据
      this.formConfigList = this.stepsList[this.stepsActive].formList;
    },
    /**
     * 验证表单
     * @param {*} i tabs切换
     */
    fun_val(i, state) {
      // 验证第一个表单
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        if (valid) {
          // 最后一个表单
          if (i === this.stepsList.length - 1) {
            // 开启弹窗
            this.$refs.caLock.dialogCalock = true;
            // 签名数据, 交易人名称和日期
            this.$refs.caLock.data =
              this.form.buildCorpCode +
              this.form.prjName +
              this.form.regulators;
            // 状态
            this.$refs.caLock.state = state;
          } else {
            // 重置表单配置
            this.formConfigList = this.stepsList[i + 1].formList;
            this.$nextTick(() => {
              // 递归验证表单
              this.fun_val(i + 1, state);
            });
          }
        } else {
          // 定位到未填表单
          this.stepsActive = i;
          // 提示
          this.$alert("页面存在错误信息，请检查后重试！", "warning");
          return false;
        }
      });
    },
    /**
     * 确定的方法
     * @author shuhua
     */
    fun_Submit(state,flag) {
      // 状态赋值
      this.form.state = state;
      // 如果时保存
      if (state === "bc" && !flag) {
        // 判断是否填写项目名称
        if (!this.form.prjName) {
          // 提示
          this.$alert("请填写项目名称！", "warning");
          this.errRules.prjName = "请填写项目名称！";
          return false;
        }
        // 保存
        this.fun_NextSaveOrUpdate(state);
        return;
      }else if (state == "bc" && flag){
        // 执行保存
        this.fun_SaveOrUpdate(state);
        return;
      }
      // 自定义下标
      let i = 0;
      // 验证当前表单
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 验证通过
        if (valid) {
          // 重置表单配置
          this.formConfigList = this.stepsList[i].formList;
          this.$nextTick(() => {
            // 验证表单
            this.fun_val(i, state);
          });
        } else {
          // 提示
          this.$alert("页面存在错误信息，请检查后重试！", "warning");
          return false;
        }
      });
    },
    /**
     * 保存或修改的方法
     * @author shuhua
     */
    fun_SaveOrUpdate(state, lockNo, digitalSignature) {
      // 状态赋值
      this.form.state = state;
      // 遍历错误消息
      for (let i in this.errRules) {
        // 设置为空
        this.errRules[i] = null;
      }
      // ca弹窗关闭
      this.$refs.caLock.dialogCalock = false;
      // 赋值锁编号
      this.form.lockNo = lockNo;
      // 赋值数字签名
      this.form.digitalSignature = digitalSignature;
      // 打开遮罩
      this.fun_Loading();
      // 发起请求
      fun_PostAction("construction/insUpd", {
        ...this.form,
        controllerFlg: this.controllerFlg
      }).then(res => {
        // 解构res.data
        const { result, msg, data } = res.data;
        // 操作成功
        if (result) {
          // 回传id
          this.id = data.id;
          // 操作成功
          this.$message.success(msg);
          // 加载框取消
          this.fullLoading.close();
          // 如果是保存  
          if(this.form.state == "bc"){
            // 修改状态
            this.controllerFlg = "update";
            // 加载详情
            this.fun_GetDetail();
          }else{
            // 返回一览
            this.fun_Back();
          }
        } else {
          // 加载框取消
          this.fullLoading.close();
          // 返回不为空
          if (data != null) {
            // 定义rules为一个随机数
            this.errRules = Math.random();
            // 执行延迟方法
            this.$nextTick(() => {
              // 提示
              this.$message.error("您输入的数据存在错误！");
              // 赋值错误消息
              this.errRules = data;
            });
            // 如果文件错误不为空
            if(data.uploadFile){
              // 定位到第一栏
              this.stepsActive = 0;
              // 重置表单配置
              this.formConfigList = this.stepsList[this.stepsActive].formList;
            }
          } else {
            // 提示请求失败消息
            this.$message.error(msg);
          }
        }
      });
    },
    /**
     * 下一步保存或修改的方法
     * @author shuhua
     */
    fun_NextSaveOrUpdate(state) {
      // 状态赋值
      this.form.state = state;
      // 打开遮罩
      this.fun_Loading();
      // 发起请求
      fun_PostAction("construction/insUpd", {
        ...this.form,
        controllerFlg: this.controllerFlg
      })
        .then(res => {
          // 解构res.data
          const { result, msg, data } = res.data;
          // 操作成功
          if (result) {
            // 回传id
            this.id = data.id;
            // 修改状态
            this.controllerFlg = "update";
            // 加载详情
            this.fun_GetDetail();
            // 加载框取消
            this.fullLoading.close();
          }
        })
        .catch(error => {
          // 加载框取消
          this.fullLoading.close();
        });
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    },
    /**
     * 清空
     * @author shuhua
     */
    fun_Clean(e) {
      // 招标项目信息清空
      if (e === "0") {
        // 清空报建编号
        this.form.constructionNo = null;
        // 清空项目名称
        this.form.prjName = null;
      } else {
        // 清空招标代理机构名称
        this.form.agencyCorpName = null;
        // 招标代理机构社会信用代码
        this.form.agencyCorpCode = null;
        // 代理机构法人姓名
        this.form.agencyCorpLegalPerson = null;
      }
    },
    /**
     * 打开招标项目选择弹窗
     * @author shuhua
     */
    fun_OpenProjectDialog() {
      // 打开弹框时调用
      this.$refs.constructionChoose.searchFlag = "1";
      // 打开弹窗
      this.$refs.constructionChoose.dialogVisible = true;
      // 请求接口
      this.$refs.constructionChoose.fun_GetList();
    },
    /**
     * 清空甲方变更项目信息
     */
    fun_CleanProject() {
      // 前次报建主键
      this.form.firstConstructionId = null;
      // 前次报建编号
      this.form.firstConstructionNo = null;
      // 前次报建项目名称
      this.form.firstConstructionPrjName = null;
      // 招标人变更类型
      this.form.tenderCorpChangeType = null;
    },
    /**
     * 全局加载
     * @author zhouzhou
     */
    fun_Loading() {
      this.fullLoading = Loading.service({
        lock: true,
        text: "正在进行效验，请耐心等待...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },

    /**
     * 投资项目查询
     * @author rsj
     */
    fun_QueryProject() {
      // 投资项目统一代码为空
      if (
        this.form.investProjectCode == "" ||
        this.form.investProjectCode == null
      ) {
        // 提示
        this.errRules.investProjectCode = "请填写投资项目统一代码！";
        return;
      }
      // 打开弹窗
      this.$refs.projectApplicationDetail.dialogVisible = false;
      // 项目代码
      this.$refs.projectApplicationDetail.form.projectCode = "";
      // 工程名称
      this.$refs.projectApplicationDetail.form.projectName = "";
      // 建设地点
      this.$refs.projectApplicationDetail.form.placeCodeName = "";
      // 建设地点详情
      this.$refs.projectApplicationDetail.form.placeCodeDetail = "";
      // 建设规模及内容
      this.$refs.projectApplicationDetail.form.scaleContent = "";
      // 所属行政区划
      this.$refs.projectApplicationDetail.form.divisionCodeName = "";
      // 建设性质
      this.$refs.projectApplicationDetail.form.projectNatureName = "";
      // 发起请求
      fun_PostAction("construction/checkProjectApplicationDetail", {
        projectCode: this.form.investProjectCode
      }).then(res => {
        // 解构res.data
        const { result, msg, data } = res.data;
        // 操作成功
        if (result) {
          // 允许报送监管
          if (data.result == "true") {
            // 打开弹窗
            this.$refs.projectApplicationDetail.dialogVisible = true;
            // 项目代码
            this.$refs.projectApplicationDetail.form.projectCode =
              data.regionApplyProjectInfo.projectCode;
            // 工程名称
            this.$refs.projectApplicationDetail.form.projectName =
              data.regionApplyProjectInfo.projectName;
            // 建设地点
            this.$refs.projectApplicationDetail.form.placeCodeName =
              data.regionApplyProjectInfo.placeCodeName;
            // 建设地点详情
            this.$refs.projectApplicationDetail.form.placeCodeDetail =
              data.regionApplyProjectInfo.placeCodeDetail;
            // 建设规模及内容
            this.$refs.projectApplicationDetail.form.scaleContent =
              data.regionApplyProjectInfo.scaleContent;
            // 所属行政区划
            this.$refs.projectApplicationDetail.form.divisionCodeName =
              data.regionApplyProjectInfo.divisionCodeName;
            // 建设性质
            this.$refs.projectApplicationDetail.form.projectNatureName =
              data.regionApplyProjectInfo.projectNatureName;
          } else {
            this.$message.error(
              "该项目代码暂未查询到项目基本信息，若确认该代码在“湖北省投资和重大项目智慧应用平台（暨省工程建设项目审批管理系统）”已备案，则可忽略！"
            );
          }
        } else {
          // 请求失败，弹出失败msg的消息提示
          this.$message.error("操作失败！");
        }
      });
    },
    /**
     * 导入
     */
    fun_Import() {
      // 打开遮罩
      this.fun_Loading();
      // 发起请求
      fun_PostAction("construction/import", {
        ...this.form,
        controllerFlg: this.controllerFlg
      }).then(res => {
        // 解构res.data
        const { result, msg, data } = res.data;
        // 操作成功
        if (result) {
          // 加载框取消
          this.fullLoading.close();
          // 操作成功
          this.$message.success(msg);
          // 返回一览
          this.$router.back();
        } else {
          // 加载框取消
          this.fullLoading.close();
          // 请求失败，弹出失败msg的消息提示
          this.$message.error("您输入的数据存在错误！");
          // 回显错误
          this.errRules = data;
        }
      });
    },

    /**
     * 打开历史核验记录弹窗
     */
    fun_OpenAuditHistoryRecord() {
      // 打开弹窗
      this.$refs.auditHistoryRecord.dialogVisible = true;
      // 请求接口
      this.$refs.auditHistoryRecord.fun_GetList();
    },

    /**
     * 下载方法
     */
    fun_GetFilePath() {
      // 发起请求
      fun_GetAction("/clientFileInfo/getAutomaticallyUpdateFiles", {
        number: 2,
        appName: "武汉市发改委项目受理、办结情况汇总表"
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 操作成功
        if (result) {
          // 不退还申请表路径
          this.url = data;
        }
      });
    },
    /**
     * 文件下载
     */
    fun_Download(e) {
      // 获取id
      fun_Download("/downloadLocal?filePath=" + e).then(res => {
        if (res) {
          // 获取头部
          let fileNames = res.headers["content-disposition"]; //获取到Content-Disposition;filename
          let regFileNames = fileNames.match(/=(.*)$/)[1];
          fun_DownloadFile(res, decodeURIComponent(regFileNames));
        }
      });
    },
    /**
     * 重新加载流程节点
     */
    fun_ReloadStepList(stepsActive) {
      // 非报建项目
      if (this.form.transactionFlag != "1") {
        // 流程数据
        this.stepsList = [
          {
            name: "项目信息导入",
            isSave: true, // 是否保存
            isActive: true, // 是否可点击
            formList: FormConfig.projectInformation()
          },
          {
            name: "建设信息",
            isSave: true,
            isActive: true, // 是否可点击,
            formList: FormConfig.biddingInformation()
          },
          {
            name: "项目基本信息",
            isSave: !stepsActive,
            isActive: !stepsActive || stepsActive === 2, // 是否可点击,
            formList: FormConfig.basicProjectInformation()
          },
          {
            name: "其他信息",
            isSave: !stepsActive,
            isActive: !stepsActive, // 是否可点击
            formList: FormConfig.noOtherInformation()
          }
        ];
        // 报建项目
      } else {
        // 流程数据
        this.stepsList = [
          {
            name: "项目信息导入",
            isSave: true, // 是否保存
            isActive: true, // 是否可点击
            formList: FormConfig.projectInformation()
          },
          {
            name: "建设信息",
            isSave: true,
            isActive: true, // 是否可点击,
            formList: FormConfig.biddingInformation()
          },
          {
            name: "项目基本信息",
            isSave: !stepsActive,
            isActive: !stepsActive || stepsActive === 2, // 是否可点击,
            formList: FormConfig.basicProjectInformation()
          },
          {
            name: "工程概况",
            isSave: !stepsActive,
            isActive: !stepsActive,
            formList: FormConfig.projectOverview()
          },
          {
            name: "其他信息",
            isSave: !stepsActive,
            isActive: !stepsActive,
            formList: FormConfig.otherInformation()
          }
        ];
      }
      // 报建项目 不为详情时
      if (this.form.transactionFlag != "0" && this.controllerFlg !== "detail") {
        // 声明需要过滤掉的数据
        var arr = ["项目登记单位意见", "办理意见"];
        // 遍历流程
        this.stepsList.map(e => {
          // 判断是其他信息
          if (e.name === "其他信息") {
            // 删除
            e.formList = e.formList.filter(item => !arr.includes(item.title));
          }
        });
      }
      // 是否目录项目
      this.fun_ProjectTypeSelect();
      // 执行处理页面显示方法
      this.fun_GetHandle();
      // 默认获取第一个流程表单
      this.formConfigList = this.stepsList[this.stepsActive].formList;
      // 初始化时处理流程判断表单是否填写内容
      this.fun_GetInitializeStepsIsData();
    },
    /**
     * 下拉框改变
     */
    fun_TransactionIdChange(e) {
      // 节点名称
      let nodeName = '';
      // 获取选中节点
      const nodes = this.$refs.transactionId.getCheckedNodes();
      // 如果选中了值
      if (nodes.length > 0) {
        // 遍历选中节点
        nodes.forEach(e => {
          // 赋值
          nodeName = e.label;
        });
      }
      // 清空招标监管部门
      this.form.regulators = "";
      // 如果长度大于0
      if (e.length > 0) {
        // 赋值
        this.form.transactionId = e[e.length - 1];
        // 设置
        this.form.transactionFlag = nodeName.indexOf('A') !== -1  ? "1" : "0";
        // 建设工程标识
        this.form.constructionFlag = nodeName.indexOf('A') !== -1  ? "1" : "0";
      } else {
        // 赋值
        this.form.transactionId = e;
      }
      // 重新加载页面流程
      this.fun_ReloadStepList();
      // 遍历查询表单
      this.stepsList[0].formList[3].formConfigList.map(f => {
        // 如果是行政监督部门
        if (f.value === "regulators") {
          // 修改下拉框请求参数，重新赋值
          f.queryParams = {
            url: "/departmentByTransCodeCombobox",
            purchaserId: this.form.transactionId
          };
        }
      });
    },
    /**
     * 获取标段（包）分类下拉框
     */
    async fun_TransactionDirectoryComboTree() {
      // 请求，获取结果集
      let res = await fun_PostAction(
        "/transactionDirectory/TransactionDirectoryComboTree?editFlg=true"
      );
      // 解构res.data
      const { result, data, msg } = res.data;
      // 操作成功
      if (result) {
        // 赋值下拉框
        this.options = data;
      } else {
        // 请求失败，提示错误信息
        this.$message.error(msg);
      }
    },
    /**
     * 附件上传
     */
    fun_GetPictureinfor() {
      // 打开弹窗
      this.$refs.tenderPictureinfor.dialogVisible = true;
      // 打开弹框时调用
      this.$refs.tenderPictureinfor.fun_GetOpen();
    },
    /**
     * 监听滚动
     */
    fun_HandleScroll(e) {
      // 判断
      if (e.target.offsetTop < this.$refs.sticky.offsetTop) {
        // 添加样式
        this.$refs.sticky.style.boxShadow = "0 0 8px 3px rgba(0, 0, 0, 0.06)";
      } else {
        // 添加样式
        this.$refs.sticky.style.boxShadow = "none";
      }
    },
    /**
     * 是否目录项目
     */
    fun_ProjectTypeSelect() {
      // 如果是目录类
      if (this.form.projectType === "0") {
        // 遍历查询表单
        this.stepsList[0].formList[3].formConfigList.map(f => {
          // 如果是交易目录名称
          if (f.value === "transactionId") {
            f.disabled = false; // 取消置灰
            f.rule.required = true; // 设置成必填
          }
          // 如果是行政监督部门
          else if (f.value === "regulators") {
            // 修改下拉框请求参数，重新赋值
            f.queryParams = {
              url: "/regulatorsCombobox",
              processType: "202303021543330348"
            };
          }
        });
      }
      // 如果是非目录类
      else {
        // 遍历查询表单
        this.stepsList[0].formList[3].formConfigList.map(f => {
          // 如果是交易目录名称
          if (f.value === "transactionId") {
            f.disabled = true; // 置灰
            f.rule.required = false; // 设置成非必填
          }
          // 如果是行政监督部门
          else if (f.value === "regulators") {
            // 修改下拉框请求参数，重新赋值
            f.queryParams = {
              url: "/regulatorsCombobox",
              processType: "201512011001350003"
            };
          }
        });
      }
    },
    /**
     * 初始化时处理流程判断表单是否填写内容
     */
    fun_GetInitializeStepsIsData() {
      // 遍历流程数据
      this.stepsList.map((item, index) => {
        // 遍历表单内容
        item.formList.map(formList => {
          // 遍历表单字段
          formList.formConfigList.map(form => {
            // 判断是否填写内容
            if (this.form[form.value]) {
              // 改变状态
              item.isSave = true;
            }
          });
        });
      });
    },
    /**
     * 用于判断当前流程是否填写数据
     */
    fun_GetStepsIsData() {
      // 声明
      var formArr = []; // 所有表单
      var isFormKey = false; // 是否填写
      // 遍历获取所有表单数据
      this.formConfigList.map(item => {
        // 判断是否存在表单
        if (item.formConfigList && item.formConfigList.length > 0)
          formArr.push(...item.formConfigList);
      });
      // 判断当前表单
      for (var i = 0; i < formArr.length; i++) {
        // 判断字段是否填写值
        if (this.form[formArr[i].value]) {
          // 改变标识
          isFormKey = true;
          // 跳出循环
          break;
        }
      }
      return isFormKey;
    }
  }
};
